import { useState } from "react";
import { useTranslation } from "react-i18next";
import { wirasanaConstant } from "../../utils/wirasanaConstant";

function Faq() {
  const [activeQ, setActiveQ] = useState("q1");
  const { t } = useTranslation();

  const openQ = (id) => {
    setActiveQ(activeQ === id ? "" : id);
  };

  const getClassAnswer = (id) => {
    return activeQ === id ? "active-answer" : "";
  };

  const getClassQuestion = (id) => {
    return activeQ === id ? "active-question" : "";
  };

  return (
    <section id="faq" className="relative py-20 overflow-hidden md:py-28 bg-gradient-to-b from-slate-50 to-white">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#f5272b] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 rounded-full left-1/4 w-96 h-96 bg-slate-800 blur-3xl"></div>
      </div>

      <div className="container relative z-10 px-4 mx-auto md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header Section */}
          <div className="mb-16 space-y-4 text-center">
            <h5 className="text-[#f5272b] font-semibold text-lg md:text-xl tracking-wide uppercase">{t("faq")}</h5>
            <h2 className="text-4xl font-bold leading-tight md:text-5xl lg:text-6xl text-slate-900">
              {t("frequently_asked")}
            </h2>
            <p className="max-w-2xl mx-auto text-lg leading-relaxed md:text-xl text-slate-600">
              {t("frequently_asked_desc")}
            </p>
            <div className="w-24 h-1.5 bg-gradient-to-r from-transparent via-[#f5272b] to-transparent mx-auto rounded-full"></div>
          </div>

          {/* FAQ Accordion */}
          <div className="space-y-4">
            {/* Question 1 */}
            <div className="group bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-slate-100 hover:border-[#f5272b]/30 overflow-hidden">
              <button
                onClick={() => openQ("q1")}
                className={`w-full px-6 md:px-8 py-6 flex items-center justify-between gap-4 transition-all duration-300 ${
                  activeQ === "q1" ? "bg-gradient-to-r from-[#f5272b]/5 to-transparent" : ""
                }`}
              >
                <div className="flex items-start flex-1 gap-4 text-left">
                  <div
                    className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
                      activeQ === "q1"
                        ? "bg-[#f5272b] text-white shadow-lg shadow-[#f5272b]/30"
                        : "bg-slate-100 text-slate-600"
                    }`}
                  >
                    <i className="text-lg fa-solid fa-question"></i>
                  </div>
                  <p
                    className={`text-lg md:text-xl font-bold transition-colors duration-300 ${
                      activeQ === "q1" ? "text-[#f5272b]" : "text-slate-900"
                    }`}
                  >
                    {t("what_is_special")}
                  </p>
                </div>
                <div
                  className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
                    activeQ === "q1" ? "bg-[#f5272b] text-white rotate-180" : "bg-slate-100 text-slate-600"
                  }`}
                >
                  <i className="fa-solid fa-chevron-down"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  activeQ === "q1" ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-6 pt-2 pb-6 md:px-8">
                  <div className="pr-4 pl-14">
                    <p className="text-base leading-relaxed text-slate-600 md:text-lg">{t("what_is_special_desc")}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Question 2 */}
            <div className="group bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-slate-100 hover:border-[#f5272b]/30 overflow-hidden">
              <button
                onClick={() => openQ("q2")}
                className={`w-full px-6 md:px-8 py-6 flex items-center justify-between gap-4 transition-all duration-300 ${
                  activeQ === "q2" ? "bg-gradient-to-r from-[#f5272b]/5 to-transparent" : ""
                }`}
              >
                <div className="flex items-start flex-1 gap-4 text-left">
                  <div
                    className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
                      activeQ === "q2"
                        ? "bg-[#f5272b] text-white shadow-lg shadow-[#f5272b]/30"
                        : "bg-slate-100 text-slate-600"
                    }`}
                  >
                    <i className="text-lg fa-solid fa-question"></i>
                  </div>
                  <p
                    className={`text-lg md:text-xl font-bold transition-colors duration-300 ${
                      activeQ === "q2" ? "text-[#f5272b]" : "text-slate-900"
                    }`}
                  >
                    {t("how_do_2")}
                  </p>
                </div>
                <div
                  className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
                    activeQ === "q2" ? "bg-[#f5272b] text-white rotate-180" : "bg-slate-100 text-slate-600"
                  }`}
                >
                  <i className="fa-solid fa-chevron-down"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  activeQ === "q2" ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-6 pt-2 pb-6 md:px-8">
                  <div className="pr-4 pl-14">
                    <p className="text-base leading-relaxed text-slate-600 md:text-lg">{t("how_do_2_desc")}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Question 3 */}
            <div className="group bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-slate-100 hover:border-[#f5272b]/30 overflow-hidden">
              <button
                onClick={() => openQ("q3")}
                className={`w-full px-6 md:px-8 py-6 flex items-center justify-between gap-4 transition-all duration-300 ${
                  activeQ === "q3" ? "bg-gradient-to-r from-[#f5272b]/5 to-transparent" : ""
                }`}
              >
                <div className="flex items-start flex-1 gap-4 text-left">
                  <div
                    className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
                      activeQ === "q3"
                        ? "bg-[#f5272b] text-white shadow-lg shadow-[#f5272b]/30"
                        : "bg-slate-100 text-slate-600"
                    }`}
                  >
                    <i className="text-lg fa-solid fa-question"></i>
                  </div>
                  <p
                    className={`text-lg md:text-xl font-bold transition-colors duration-300 ${
                      activeQ === "q3" ? "text-[#f5272b]" : "text-slate-900"
                    }`}
                  >
                    {t("how_do_3")}
                  </p>
                </div>
                <div
                  className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
                    activeQ === "q3" ? "bg-[#f5272b] text-white rotate-180" : "bg-slate-100 text-slate-600"
                  }`}
                >
                  <i className="fa-solid fa-chevron-down"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-500 ${
                  activeQ === "q3" ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-6 pt-2 pb-6 md:px-8">
                  <div className="pr-4 pl-14">
                    <p className="text-base leading-relaxed text-slate-600 md:text-lg">{t("how_do_3_desc")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="p-8 mt-12 text-center border shadow-2xl bg-gradient-to-r from-slate-800 to-slate-900 rounded-3xl md:p-10 border-slate-700">
            <div className="max-w-2xl mx-auto space-y-4">
              <div className="w-16 h-16 bg-[#f5272b] rounded-2xl flex items-center justify-center mx-auto shadow-lg shadow-[#f5272b]/30">
                <i className="text-3xl text-white fa-solid fa-headset"></i>
              </div>
              <h3 className="text-2xl font-bold text-white md:text-3xl">Still Have Questions?</h3>
              <p className="text-lg text-slate-300">Our support team is here to help you 24/7</p>
              <div className="flex flex-col items-center justify-center gap-4 pt-4 sm:flex-row">
                <a
                  href={`https://wa.me/${wirasanaConstant.whatsapp}`}
                  className="inline-flex items-center gap-3 px-8 py-4 bg-[#f5272b] hover:bg-red-700 text-white font-bold rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 group"
                >
                  <i className="text-xl fa-brands fa-whatsapp"></i>
                  Contact Us
                  <i className="transition-transform fa-solid fa-arrow-right group-hover:translate-x-1"></i>
                </a>
                <a
                  href="tel:03612860066"
                  className="inline-flex items-center gap-3 px-8 py-4 font-bold text-white transition-all duration-300 border shadow-lg bg-slate-700 hover:bg-slate-600 rounded-2xl hover:shadow-xl border-slate-600"
                >
                  <i className="text-lg fa-solid fa-phone"></i>
                  Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Faq;
